import React from 'react'

import styles from './CardsList.module.scss'

export default ({ children }) => <div className={styles.cardsList}>{children}</div>
